import { Block, HeadingXSmall, useStyletron } from "@mezo-org/mezo-clay"

import HomepageMainSectionAssets from "./HomepageMainSectionAssets"
import HomepageMainSectionBorrow from "./HomepageMainSectionBorrow"
import HomepageMainSectionClaim from "./HomepageMainSectionClaim"

export default function HomepageMainSectionUser() {
  const [, theme] = useStyletron()

  return (
    <Block paddingBottom={theme.sizing.scale1200}>
      <HeadingXSmall marginBottom={theme.sizing.scale600}>
        Your assets
      </HeadingXSmall>
      <HomepageMainSectionAssets />
      <HomepageMainSectionBorrow />
      <HomepageMainSectionClaim />
    </Block>
  )
}
